<template>
  <header id="navbar" class="fixed w-full z-50 transition-all duration-300 bg-white backdrop-blur-sm">
    <nav class="container mx-auto px-6 md:px-12 py-4">
      <div class="flex justify-between items-center">
        <a href="#" class="text-2xl md:text-3xl font-display font-bold flex items-center">
          <a v-router-a href="/index#home">
            <img
              :src="filePath + ('/nemojoyWebSiteFile/imgs/indexHead/indexHeadLogo_black.png')"
              alt=""
              draggable="false"
              class="h-8 lg:h-14"
            >
          </a>
        </a>

        <!-- 桌面导航 -->
        <div v-if="navShow" class="hidden md:flex items-center space-x-8">
          <a v-router-a href="/index#home" class="nav-item active text-dark-text hover:text-primary transition-colors">首页</a>
          <a v-router-a href="/index#games" class="nav-item text-dark-text hover:text-primary transition-colors">游戏产品</a>
          <a v-router-a href="/index#news" class="nav-item text-dark-text hover:text-primary transition-colors">新闻动态</a>
          <a v-router-a href="/index#job" class="nav-item text-dark-text hover:text-primary transition-colors">加入我们</a>
        </div>

        <!-- 移动端菜单按钮 -->
        <button id="menu-toggle" class="md:hidden text-dark-text text-2xl focus:outline-none" @click="menuShow = !menuShow">
          <i class="fa fa-bars" />
        </button>
      </div>
    </nav>

    <!-- 移动端导航菜单 -->
    <div v-if="menuShow" id="mobile-menu" class="md:hidden bg-white border-t border-gray-100 z-50">
      <div class="container mx-auto px-4 py-4 flex flex-col space-y-4">
        <a v-router-a href="/index" class="text-dark-text hover:text-primary py-2 transition-colors" @click="menuShow = false">首页</a>
        <a v-router-a href="/index#games" class="text-dark-text hover:text-primary py-2 transition-colors" @click="menuShow = false">游戏作品</a>
        <a v-router-a href="/index#news" class="text-dark-text hover:text-primary py-2 transition-colors" @click="menuShow = false">新闻动态</a>
        <a v-router-a href="/index#job" class="text-dark-text hover:text-primary py-2 transition-colors" @click="menuShow = false">加入我们</a>
      </div>
    </div>
  </header>
</template>
<script>
import vv from '@/components/varVariable'

export default {
  name: 'Header',
  data() {
    return {
      menuShow: false,
      navShow: true
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  mounted() {
    // 初始加载时获取一次
    this.getCurrentUrl()

    // 绑定滚动事件
    document.addEventListener('DOMContentLoaded', () => {
      // 绑定到window（全局滚动）
      window.addEventListener('scroll', this.getCurrentUrl)
    })
  },
  methods: {
    getCurrentUrl() {
      // 路径部分
      const routePath = window.location.pathname
      // 当前section部分
      let current = ''
      const sections = document.querySelectorAll('section')
      sections.forEach(section => {
        const sectionTop = section.offsetTop
        if (window.scrollY >= (sectionTop - 150)) {
          current = section.getAttribute('id') || ''
        }
      })

      // 这里可以根据需求处理 URL（如存储、展示等）
      const pathSection = routePath + current
      this.navShow = (pathSection !== '/index' && pathSection !== '/indexhome' && pathSection !== '/')
    }
  }
}
</script>
<style lang="scss">
@media screen and (min-width: 800px){
  .index_pc_head_logo{
    img{
      max-width: 9.8rem;
    }
  }
}

@media screen and (max-width: 800px){
  .index_pc_head_logo{
    height: 100%;
    img{
      height: 5.2rem;
    }
  }
}
</style>
